import React, {useEffect, useState, useRef} from "react";
import { useNavigate } from "react-router-dom";
import Col from "olive-react-myoneui/lib/Col";
import ProfileImageUploader from "./ProfileImageUploader";
import Dropdown from "olive-react-myoneui/lib/Dropdown";
import { dotsIcon, downChevArrow, envelopeIcon, geoMarkIcon, insertPdfIcon, phoneIcon, qrIcon, settings, users, uploadIcon,  zipIcon, imageIcon, checkCircleComplete, binIcon, bannerIcon} from '../../../constants/icons';
import { useDispatch, useSelector } from "react-redux";
import { generateQr, getGeneratedQr } from "../../../../api/afterLogin/qr";
import { downloadPdf, downloadZip } from "../../../../api/afterLogin/downloads";
import { Button, CircleImage, Container, Row, Toast, ToastInfo } from "olive-react-myoneui";
import { Buffer } from 'buffer';
import axios from "../../../../utils/axios";
import ModalCommon from "../ModalCommon";
import Cropper from "react-cropper";
import ProgressWrap from "olive-react-myoneui/lib/ProgressWrap";
import ProgressBar from "olive-react-myoneui/lib/ProgressBar";
import ProgressValue from "olive-react-myoneui/lib/ProgressValue";
import { Spinner } from "olive-react-myoneui";
import "cropperjs/dist/cropper.css";
import { setConfigData } from "../../../../reducers/configSlice";
import { uploadBannerImage } from "../../../../api/afterLogin/upload";

const MAX_FILE_SIZE_MB = 3;
const MAX_FILE_SIZE = MAX_FILE_SIZE_MB * 1024 * 1024; // 3MB in bytes
const ALLOWED_FILE_TYPES = ["image/jpeg", "image/png"];

function ProfileHeader({
    className = '',
    defaultProfileImg,
    name,
    email,
    phone,
    location,
    viewProfileLink,
    dropdownDownloadItems,
    dotDropdownItems,
    publicProfile,
    publicProfileImage,
    profileBannerImgUrl,
    publicProfileBannerImgUrl = '',
}) {
    const dispatch = useDispatch();
    const configData       = useSelector((state) => state.config);
    const tmp_banner_image = useSelector((state) => state.config.tmp_banner_image);
    const paths            = useSelector((state) => state.user.paths);
    const website          = useSelector((state) => state.user.website);
    const navigate = useNavigate();
    const [QRData,setQRData] = useState({});
    const [showQrToast, setShowQrToast] = useState(false);
    const [showPdfToast, setShowPdfToast] = useState(false);
    const [showZipPdfErrorToast, setShowZipPdfErrorToast] = useState(false);
    const [showZipToast, setShowZipToast] = useState(false);
    const [showDocToast, setShowDocToast] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [showModal, setShowModal] = useState(true);
    const [profileImageLoading, setProfileImageLoading] = useState(false);
    const [cropperVisible, setCropperVisible] = useState(false);
    const [cropperImage, setCropperImage] = useState(null);
    const [uploadProgress, setUploadProgress] = useState(0);
    const [error, setError] = useState(null);
    const [uploadedFile, setUploadedFile] = useState(null);
    const cropperRef = useRef(null);
    const [tempImagePreview, setTempImagePreview] = useState(null);
    const [selectedFile, setSelectedFile] = useState(null);
    const [blob, setBlob] = useState(null);
    const [bannerBg, setBannerBg] = useState(null);
    const [imagePreview, setImagePreview] = useState(null);

    useEffect(() => {
        if (configData?.success_doc) {
        setShowDocToast(true);
        dispatch(setConfigData({ success_doc: false }));
        }
    }, [configData?.success_doc]);
  
    const generatePublicQR = async () => {
        const qr = await generateQr(configData.access_token, configData.session.us_account_id, configData.session.us_uuid);
        if(qr.status === 200) {
            setShowQrToast(true);
            getQr();
        }
    };

    const getQr = async () => {
       const qr = await getGeneratedQr(configData.access_token);
       setQRData(qr.data);
    }

    let profileImage;
    if(!publicProfile) {
        if(configData.session.us_image === "default.jpg") {
            profileImage = `${configData.s3_url}uploads/default/user/${configData.session.us_image}`;
        } else {
            profileImage = `${configData.s3_url}uploads/${window.location.host}/items_org/user/${configData.session.us_image}`;
        }  
    } else {
        profileImage = publicProfileImage;
    }

    useEffect(()=>{
        getQr();
    },[]);

    const handleGenerateQR = () => {
        generatePublicQR();
    };

    const handleSettingsRedirect = () => {
        navigate("/student-dashboard/settings");
    };

    const handlePublicProfileRedirect = async () => {
        const getLearnerdata = async () => {
            let loggedInData = await axios.request({
            url:`${window.location.origin}/login/login_check`,
            method: "get",
            });
            return loggedInData.data.session.user;
        }

        const learnerUpdatedData = await getLearnerdata();
    
        let public_id;
        if(learnerUpdatedData.us_qr_generated == 1) {
            const random_id = learnerUpdatedData.us_qr_filename.split('.')[0];
            public_id = `${learnerUpdatedData.us_account_id}_${learnerUpdatedData.us_uuid}_${random_id}`;
        } else {
            public_id = '';
        }

        window.open(`/public-profile/${Buffer.from(public_id, 'utf-8').toString('base64')}`, '_blank');
    };

    const handleDownloadPDF = () => { 
        if((configData.certificatecount + configData.coursecount + configData.externaldoccount + configData.programcount) == 0) {
            setShowZipPdfErrorToast(true);
            return;
        }
        setShowPdfToast(true);
        downloadPdf(configData.session.id);
    }

    const handleDownloadZip = () => {
        if((configData.certificatecount + configData.coursecount + configData.externaldoccount + configData.programcount) == 0) {
            setShowZipPdfErrorToast(true);
            return;
        }
        setShowZipToast(true);
        downloadZip(configData.session.id);
    }

    const handleBannerImage = () => {
        setIsModalOpen(true);
    }

    const closeModal = () => {
        setIsModalOpen(false);
        resetModalState();
    };

    const handleDragOver = (event) => {
        event.preventDefault();
        event.stopPropagation();
    };
      
    const handleDrop = (event) => {
        event.preventDefault();
        event.stopPropagation();
        
        const file = event.dataTransfer.files[0];
    
        if (file) {
          handleImageChange({ target: { files: [file] } });
        }
    };

    const handleImageChange = (event) => {
        setError(null); // Clear previous errors
        const file = event.target.files[0];
        if (file) {
          if (!ALLOWED_FILE_TYPES.includes(file.type)) {
            setError("Invalid file type. Only .jpg and .png files are allowed.");
            return;
          }
          if (file.size > MAX_FILE_SIZE) {
            setError(`File size exceeds the ${MAX_FILE_SIZE_MB}MB limit.`);
            return;
          }
          setSelectedFile(file);
          const reader = new FileReader();
          reader.onload = () => {
            setTempImagePreview(reader.result);
            setCropperImage(reader.result);
            setCropperVisible(true);
          };
          reader.readAsDataURL(file);
        }
    };
    
    const handleCrop = () => {
        if (cropperRef.current) {
          const croppedCanvas = cropperRef.current.cropper.getCroppedCanvas();
          if (croppedCanvas) {
            croppedCanvas.toBlob((blob) => {
              if (blob) {
                setBlob(blob);
                const croppedFile = new File([blob], selectedFile.name, {
                  type: selectedFile.type,
                  lastModified: Date.now(),
                });
                setUploadedFile(croppedFile);
                simulateUploadProgress();
    
              }
            }, selectedFile.type);
          }
          setCropperVisible(false);
        }
    };
    
    const simulateUploadProgress = () => {
        setUploadProgress(0);
        const interval = setInterval(() => {
          setUploadProgress((prev) => {
            if (prev >= 100) {
              clearInterval(interval);
              return 100;
            }
            return prev + 10;
          });
        }, 200);
    };
    
    const handleSave = async () => {
        setProfileImageLoading(true);
        const croppedCanvas = cropperRef.current.cropper.getCroppedCanvas();
        if (croppedCanvas) {
          dispatch(setConfigData({ tmp_banner_image: croppedCanvas.toDataURL() }));
          setImagePreview(croppedCanvas.toDataURL());
        }
    
        let formData = new FormData();
        formData.append("banner_image", blob, uploadedFile.name);
    
        await uploadBannerImage(configData.access_token, formData);
        
        setIsModalOpen(false);
        setProfileImageLoading(false);
        resetModalState();
    };

    const handleCancelUpload = () => {
        setUploadedFile(null);
        setTempImagePreview(null);
        setUploadProgress(0);
        setCropperImage(null);
        setCropperVisible(false);
        setError(null); // Clear error state
    };

    const resetModalState = () => {
        setIsModalOpen(false);
        setUploadedFile(null);
        setTempImagePreview(null);
        setUploadProgress(0);
        setCropperImage(null);
        setCropperVisible(false);
        setSelectedFile(null);
        setError(null);
    };

    useEffect(() => {
        if(publicProfile) {
            setBannerBg(publicProfileBannerImgUrl);
        } else {
            const imageUrl = imagePreview
              ? imagePreview
              : configData.session.us_banner_image === 'default-banner.jpg' 
                ? profileBannerImgUrl 
                : `${configData.s3_url}uploads/${window.location.host}/items_org/user/banner/${configData.session.us_banner_image}`;
            setBannerBg(imageUrl);
        }
      }, [imagePreview]);
  
    return (
        <>
            <div className={`${className} myk__stu-setting-body-wrapper`}>
                <div className="myk_stu-avatar-inner d-flex align-items-start align-items-sm-start gap-sm-3 gap-0 justify-content-between flex-sm-row flex-column">
                    {bannerBg && (
                        <img src={bannerBg} className="img-fluid myk__stu-banner-image"/>
                    )}
                    <div className="myk_stu-avatar_info-wrapper">
                        <ProfileImageUploader profileImage={profileImage} defaultImage={defaultProfileImg} publicProfile={publicProfile}/>
                        <div className="myk_stu-profile-details">
                            <h2>{name}</h2>
                            <div className="myk_stu-profile-metadata">
                                <ul className="d-flex align-items-center flex-wrap gap-3">
                                    {email &&
                                    <li>
                                        <a href={`mailto:${email}`}>
                                            <span>{envelopeIcon}</span>
                                            <span>{email}</span>
                                        </a>
                                    </li>
                                    }
                                    {phone &&
                                        <li>
                                            <a href={`tel:${phone}`}>
                                                <span>{phoneIcon}</span>
                                                <span>{phone}</span>
                                            </a>
                                        </li>
                                    }
                                    {location &&
                                        <li>
                                            <a href="#">
                                                <span>{geoMarkIcon}</span>
                                                <span>{location}</span>
                                            </a>
                                        </li>
                                    }
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div className="mky_fullprofile-drop_options">
                        <div className="mky_fullprofile-drop_options qr-dd-dots">
                            {viewProfileLink &&
                                <Button onClick={viewProfileLink} className="btn btn-round btn-view-profile bg-white border-white text-primary d-flex align-items-center gap-1">
                                    <span>View Profile</span>
                                </Button>
                            }
                            {
                                !publicProfile &&
                                <>
                                    {QRData.qr_enabled === "1" && (
                                    <div className="myk__stu-public-qr">
                                        <p>Scan QR to view public profile</p>
                                        <img src={`${configData.s3_url}${QRData.qr_link}`} alt="QR Code" className="img-fluid" />
                                    </div>
                                    )}
                                    {dropdownDownloadItems &&
                                        <Dropdown className={`profile-download-dropdown dropdown-select text-end`} align="end">
                                            <Dropdown.Toggle
                                            as="div"
                                            role="button"
                                            tabIndex={0}
                                            className="btn px-3"
                                            ><span>Download profile</span><span className="ms-1">{downChevArrow}</span></Dropdown.Toggle>
                                            <Dropdown.Menu className="dropdown-menu mw-dropdown-default">
                                            <Dropdown.Item eventKey="1" onClick={handleDownloadPDF}>
                                                {insertPdfIcon} PDF File
                                            </Dropdown.Item>
                                            <Dropdown.Item eventKey="2" onClick={handleDownloadZip}>
                                                {zipIcon} Zip Bundle File
                                            </Dropdown.Item>
                                            </Dropdown.Menu>
                                        </Dropdown>
                                    }
                                    {dotDropdownItems &&
                                        <Dropdown className={`dots-dropdown dropdown-select text-end`} align="end">
                                            <Dropdown.Toggle
                                            as="div"
                                            role="button"
                                            tabIndex={0}
                                            className="btn px-0"
                                            >{dotsIcon}</Dropdown.Toggle>
                                            <Dropdown.Menu className="dropdown-menu mw-dropdown-default">
                                            {
                                                QRData.qr_enabled === "0" && (
                                                    <Dropdown.Item eventKey="1" onClick={handleGenerateQR}>
                                                        {qrIcon} Generate QR
                                                    </Dropdown.Item>
                                                )
                                            }
                                            {QRData?.qr_enabled !== "0" && (
                                            <Dropdown.Item eventKey="2" onClick={handlePublicProfileRedirect}>
                                                {users} Public Profile
                                            </Dropdown.Item>
                                            )}
                                            <Dropdown.Item eventKey="2" onClick={handleSettingsRedirect}>
                                                {settings} Settings
                                            </Dropdown.Item>
                                            </Dropdown.Menu>
                                        </Dropdown>
                                    }
                                    <Button onClick={handleBannerImage} className="btn btn-round bg-transparent border-white text-white d-flex align-items-center gap-2 myk__stu-upload-cover-image">
                                        {bannerIcon} <span>Edit Cover Image</span>
                                    </Button>
                                </>
                            }
                            {/* Only show for Public Profile */}
                            {publicProfile && (
                                <div className="myk__stu-public-logo">
                                    <img src={paths.logo_path+website.site_logo} alt="Company Logo" className="img-fluid" />
                                </div>
                            )}
                        </div>
                    </div>
                </div>
                
                <div style={{ display: showZipToast ? 'block' : 'none' }}>
                    <Toast variant="primary" className="mb-2 mt-4">
                        <Toast.Body>
                        <ToastInfo toastDescription="Your portfolio zip file is being prepared. You will soon receive the portfolio zip file in your email, and you can download it from there. " />
                        <div className="action-wrapper">
                            <Button
                            variant="primary"
                            type="button"
                            size="sm"
                            className="btn-round bg-primary-fade"
                            aria-label="Close"
                            onClick={() => setShowZipToast(false)}
                            >
                            Close
                            </Button>
                        </div>
                        </Toast.Body>
                    </Toast>
                </div>
                
                <div style={{ display: showZipPdfErrorToast ? 'block' : 'none' }}>
                    <Toast variant="error" className="mb-2 mt-4">
                        <Toast.Body>
                        <ToastInfo toastDescription="You must have alteast one courses, programs or external docs to download profile." />
                        <div className="action-wrapper">
                            <Button
                            variant="error"
                            type="button"
                            size="sm"
                            className="btn-round bg-orange-fade text-white"
                            aria-label="Close"
                            onClick={() => setShowZipPdfErrorToast(false)}
                            >
                            Close
                            </Button>
                        </div>
                        </Toast.Body>
                    </Toast>
                </div>

                <div style={{ display: showPdfToast ? 'block' : 'none' }}>
                    <Toast variant="primary" className="mb-2 mt-4">
                        <Toast.Body>
                        <ToastInfo toastDescription="Your portfolio pdf file is being prepared. You will soon receive the portfolio pdf file in your email, and you can download it from there. " />
                        <div className="action-wrapper">
                            <Button
                            variant="primary"
                            type="button"
                            size="sm"
                            className="btn-round bg-primary-fade"
                            aria-label="Close"
                            onClick={() => setShowPdfToast(false)}
                            >
                            Close
                            </Button>
                        </div>
                        </Toast.Body>
                    </Toast>
                </div>

                <div style={{ display: showQrToast ? 'block' : 'none' }}>
                    <Toast variant="primary" className="mb-2 mt-4">
                        <Toast.Body>
                        <ToastInfo toastDescription="QR generated successfully!" />
                        <div className="action-wrapper">
                            <Button
                            variant="primary"
                            type="button"
                            size="sm"
                            className="btn-round bg-primary-fade"
                            aria-label="Close"
                            onClick={() => setShowQrToast(false)}
                            >
                            Close
                            </Button>
                        </div>
                        </Toast.Body>
                    </Toast>
                </div>

                <div style={{ display: showDocToast ? 'block' : 'none' }}>
                    <Toast variant="primary" className="mb-2 mt-4">
                        <Toast.Body>
                        <ToastInfo toastDescription="Document Uploaded Successfully." />
                        <div className="action-wrapper">
                            <Button
                            variant="primary"
                            type="button"
                            size="sm"
                            className="btn-round bg-primary-fade"
                            aria-label="Close"
                            onClick={() => setShowDocToast(false)}
                            >
                            Close
                            </Button>
                        </div>
                        </Toast.Body>
                    </Toast>
                </div>
            </div>

            {isModalOpen && (
                <ModalCommon
                backdrop="static"
                show={showModal}
                onClose={closeModal}
                title="Upload Cover Image"
                className="myk__stu-question-modal"
                backdropOption="static"
                >
                {profileImageLoading == false ? (
                    <>
                    <div className="text-center">
                    {!cropperVisible ? (
                        <div className={`upload-container ${uploadProgress < 100 ? "" : "upload-disabled"}`} onDragOver={handleDragOver} onDrop={handleDrop} >
                        <label htmlFor="image-upload-input" className="upload-area">
                            <CircleImage className="circle-wrap circle-wrap-sm">
                            {uploadIcon}
                            </CircleImage>
                            <p>Click to upload or drag and drop</p>
                            <p>File format: .jpg, .png (max file size: {MAX_FILE_SIZE_MB}MB)</p>
                        </label>
                        <input
                            type="file"
                            id="image-upload-input"
                            accept="image/*"
                            style={{ display: "none" }}
                            onChange={handleImageChange}
                        />
                        </div>
                        ) : (
                        <Cropper
                        src={cropperImage}
                        style={{ height: 400, width: "100%" }}
                        aspectRatio={24 / 9}
                        guides={false}
                        ref={cropperRef}
                        />
                        )}
                        {error && <p className="text-danger">{error}</p>} {/* Display errors */}
                        {uploadedFile && (
                        <div className="myk__stu-upload-details">
                            <div className="information-block information-block-sm-pd bg-ghost-white mb-3 text-start">
                            <div className="information-wrap">
                                <div className="information-holder">
                                <CircleImage className="circle-wrap circle-wrap-sm bg-white text-success">
                                    {imageIcon}
                                </CircleImage>
                                <div className="information-detail">
                                    <h4>{uploadedFile.name} {uploadProgress < 100 ? '' : checkCircleComplete}</h4>
                                    {uploadProgress < 100 ? (
                                    <ProgressWrap>
                                        <ProgressBar variant="primary" now={uploadProgress} />
                                        <ProgressValue ProgressPercentage={`${uploadProgress}%`} />
                                    </ProgressWrap>
                                    ) : (
                                    <div className="d-flex align-items-center gap-2">
                                        <span>{(uploadedFile.size / (1024 * 1024)).toFixed(1)} MB</span>
                                        <span>- {uploadProgress}% Uploaded</span>
                                    </div>
                                    )}
                                </div>
                                </div>
                                <Button
                                variant="information-white-bg"
                                className="btn btn-sm btn-round"
                                onClick={handleCancelUpload}
                                >
                                {binIcon}
                                </Button>
                            </div>
                            </div>
                        </div>
                        )}
                    </div>
                    <Row>
                        <Col className="text-end mt-3">
                        <Button variant="default" onClick={closeModal}>Cancel</Button>
                        {cropperVisible && <Button variant="primary" onClick={handleCrop}>Crop Image</Button>}
                        {!cropperVisible && <Button variant="primary" onClick={handleSave} type="submit" disabled={!tempImagePreview || uploadProgress < 100 || !selectedFile}>Save</Button>}
                        </Col>
                    </Row>
                    </>
                ) : (
                    <div className="text-center">
                    <div className="myk__upload-img-loader w-100 d-flex align-items-center justify-content-center">
                        <div className="d-flex align-items-center justify-content-center flex-column gap-2">
                        <Spinner animation="border" variant="secondary" />
                        <span>Uploading Banner image...</span>
                        </div>
                    </div>
                    </div>
                ) }
                </ModalCommon>
            )}
        </>
    );
}

export default ProfileHeader;
